import { HTMLContent } from './HTMLContent'
import { RichText } from './RichText'

export class ListItems extends HTMLContent {
  add(content) {
    this.content.push(new RichText({ content }).parse().content)
  }
}



// WEBPACK FOOTER //
// ./src/api/classes/ListItems.js